/**
 * 回答者・候補者に案内する mento の公開URL。
 *
 * 依頼メールの文面と日程調整ページの両方から参照する。片方だけ差し替わるのを防ぐため、
 * 管理者向け・候補者向けのどちらにも寄せず共有の置き場に置く。
 */
export const PRIVACY_POLICY_URL = "https://biz.mento.jp/privacy";
export const CONTACT_FORM_URL =
  "https://mentohelp.zendesk.com/hc/ja/requests/new";
